import * as React from 'react';

export default ({ color = '#616161', size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      display: 'block',
    }}
  >
    <g clipPath="url(#clip0)">
      <path
        d="M8 0.67C3.96 0.67 0.67 3.96 0.67 8c0 4.04 3.29 7.33 7.33 7.33 4.04 0 7.33-3.29 7.33-7.33 0-4.04-3.29-7.33-7.33-7.33Z"
        fill="#D4D4D4"
      />
      <path d="M8 4V5.45" stroke={color} strokeLinecap="round" strokeLinejoin="round" className="stick" />
      <path d="M10.83 5.17L9.8 6.2" stroke={color} strokeLinecap="round" strokeLinejoin="round" className="stick" />
      <path d="M12 8h-1.45" stroke={color} strokeLinecap="round" strokeLinejoin="round" className="stick" />
      <path d="M10.83 10.83L9.8 9.8" stroke={color} strokeLinecap="round" strokeLinejoin="round" className="stick" />
      <path d="M8 12v-1.45" stroke={color} strokeLinecap="round" strokeLinejoin="round" className="stick" />
      <path d="M5.17 10.83L6.2 9.8" stroke={color} strokeLinecap="round" strokeLinejoin="round" className="stick" />
      <path d="M4 8h1.45" stroke={color} strokeLinecap="round" strokeLinejoin="round" className="stick" />
      <path d="M5.17 5.17L6.2 6.2" stroke={color} strokeLinecap="round" strokeLinejoin="round" className="stick" />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
    <style>
      {`
        @keyframes fade {
          0%   { opacity: 1; }
          50%  { opacity: 0.2; }
          100% { opacity: 1; }
        }
        .stick {
          animation: fade 1.2s linear infinite;
        }
        .stick:nth-of-type(2) { animation-delay: 0.15s; }
        .stick:nth-of-type(3) { animation-delay: 0.3s; }
        .stick:nth-of-type(4) { animation-delay: 0.45s; }
        .stick:nth-of-type(5) { animation-delay: 0.6s; }
        .stick:nth-of-type(6) { animation-delay: 0.75s; }
        .stick:nth-of-type(7) { animation-delay: 0.9s; }
        .stick:nth-of-type(8) { animation-delay: 1.05s; }
      `}
    </style>
  </svg>
);
